import angular from "angular";
import { RecordGridViewController } from "./controller";

export const vsComponentName = "recordGridView";

export const RecordGridViewComponentOptions: angular.IComponentOptions = {
  controller: RecordGridViewController,
  controllerAs: "recordGridViewController",
  template: require("!html-loader!./index.html").default,
  bindings: {
    gridDataSource: "<",
    gridSettings: "<?",
    columns: "<",
    defaultSort: "<?",
    defaultQuery: "<?",
    nameSingular: "<",
    namePlural: "<?",
    showAddButton: "<?",
    showAddButtonPermission: "<?",
    onItemCommand: "&?",
    gridSelectionChanged: "&?",
    showSelectButtons: "<?",
    initialSelectedIds: "<?",
    onAddNew: "&?",
  },
  transclude: {
    commandRow: "?commandRow",
    gridHeader: "?gridHeader",
    addButton: "?addButton",
  },
};
